/**
 * A sample hashing function, from Ryan's suggestion.
 * @param {string} input
 * Perhaps it could be even more secure atob and btoa methods
 * as he used it from bookmark.js / articles
 */

export default function getHash(input) {
  var hash = 0,
    len = input.length;
  for (var i = 0; i < len; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0; // to 32bit integer
  }
  return hash.toString();
}

/**
 * A string kebab case function
 * @param {string} string
 * Converts string to lowercase
 * Replace non-alphanumeric characters with hyphens
 * Remove leading and trailing hyphens
 */
function toKebabCase(string) {
  return string
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export { getHash, toKebabCase };
